import { UserRole } from "enums";

export const GENERATE_LOGIN_URL_LABEL = "Gerar URL de Login";

export const GENERATE_LOGIN_URL_UNAVAILABLE_LABEL =
  "Orçamento sem número de controle — URL indisponível";

export const LOGIN_URL_OPENED_MESSAGE = "Tela de login aberta em uma nova aba.";

export const LOGIN_URL_COPIED_MESSAGE =
  "URL copiada para a área de transferência.";

export const LOGIN_URL_COPY_FAILED_MESSAGE =
  "Não foi possível copiar. Selecione a URL e copie manualmente.";

export const LOGIN_URL_MODAL_TITLE = "Gerar URL de Login";

export const LOGIN_URL_MODAL_DESCRIPTION =
  "A tela de login do orçamento abre em uma nova aba, já identificada por este orçamento. O titular continua precisando da senha para entrar.";

export const LOGIN_URL_MODAL_WARNING =
  "A URL continua válida enquanto o orçamento existir. A geração fica registrada em Auditoria com o seu usuário.";

export const LOGIN_URL_BLOCKED_WARNING =
  "O navegador bloqueou a abertura da nova aba. A URL já foi gerada e já foi auditada — abra pelo botão abaixo ou copie para o canal do atendimento.";

export const LOGIN_URL_BLOCKED_FOOTER =
  "A URL continua válida enquanto o orçamento existir. Ao fechar, ela não é exibida novamente — será preciso gerar de novo.";

const ALLOWED_PERMISSIONS = new Set<string>([
  UserRole.Admin,
  UserRole.ReportsFull,
]);

export type GenerateLoginUrlResponse = {
  url?: string;
};

type ErrorLike = {
  statusCode?: number;
  response?: {
    status?: number;
  };
};

export const canUseGenerateLoginUrl = (permissions?: unknown): boolean => {
  if (Array.isArray(permissions)) {
    return permissions.some((permission) =>
      ALLOWED_PERMISSIONS.has(String(permission)),
    );
  }

  return ALLOWED_PERMISSIONS.has(String(permissions));
};

export const isLoginUrlEligible = (
  controlNumber?: string | number | null,
): boolean => Boolean(controlNumber);

export const getLoginUrlErrorMessage = (error?: unknown): string => {
  const status =
    typeof error === "number"
      ? error
      : ((error as ErrorLike | undefined)?.statusCode ??
        (error as ErrorLike | undefined)?.response?.status);

  switch (status) {
    case 403:
      return "Você não tem permissão para gerar a URL de login deste orçamento.";
    case 404:
      return "Orçamento não encontrado.";
    case 422:
      return "Operadora do orçamento não tem URL de acesso configurada. Acione o time responsável pela parametrização.";
    case 502:
      return "Não foi possível gerar a URL no momento. Tente novamente mais tarde.";
    default:
      return "Não foi possível gerar a URL no momento. Tente novamente mais tarde.";
  }
};
